import { type BuilderCtx, CAP, type Collection } from './shared.ts'
import { sortByStale } from '../filter.ts'

export const buildDateRow = ({ activities }: BuilderCtx): Collection => ({
	key: 'date',
	title: 'Just the two of you',
	activities: activities
		.filter((a) => a.audience.includes('date'))
		.sort(sortByStale)
		.slice(0, CAP),
	seeAll: { audiences: ['date'] },
})
